<form [formGroup]="formGroup">
	<h1 mat-dialog-title>{{title}}</h1>

	<mat-dialog-content class="dialog-content">
		<div class="field-row ">
			<div class="field-row-title">
				{{fieldName}}
			</div>
			<div class="field-row-element">
				<mat-form-field subscriptSizing="dynamic">
					<input matInput
						   name="value"
						   cdkFocusInitial
						   formControlName="value"
						   required>
					@if (formGroup.controls.value.invalid) {
						<mat-error>{{formGroup.controls.value.errors.invalid}}</mat-error>
					}
				</mat-form-field>
			</div>
		</div>
		@if (performingAction || formGroup.pending) {
			<mat-progress-bar mode="indeterminate"></mat-progress-bar>
		}
		@if (actionError) {
			<mat-error>{{actionError}}</mat-error>
		}
	</mat-dialog-content>

	<mat-dialog-actions>
		<button mat-stroked-button
				mat-dialog-close>
			Cancel
		</button>
		<button mat-flat-button
				type="submit"
				[disabled]="!formGroup.dirty || formGroup.invalid"
				(click)="performAction()">
			{{ actionLabel }}
		</button>
	</mat-dialog-actions>
</form>
